import { render, staticRenderFns } from "./import-from-expert-modal-loader.vue?vue&type=template&id=4f80e453"
import script from "./import-from-expert-modal-loader.vue?vue&type=script&lang=ts"
export * from "./import-from-expert-modal-loader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports